import { useState, useEffect } from 'react'
import { fmtEur } from '@/shared/lib'
import { statsApi } from '@/shared/api'

export function StatsBlock() {
  const [totalEur, setTotalEur] = useState(0)
  const [totalDeals, setTotalDeals] = useState(0)
  const [activeUsers, setActiveUsers] = useState(0)
  const [todayProfit, setTodayProfit] = useState(0)

  useEffect(() => {
    const poll = async () => {
      try {
        const data = await statsApi.get()
        setTotalEur(data.totalProfit)
        setTodayProfit(data.todayProfit)
        setTotalDeals(data.totalDeals)
        setActiveUsers(data.activeUsers)
      } catch { /* keep last values */ }
    }
    void poll()
    const id = setInterval(poll, 1000)
    return () => clearInterval(id)
  }, [])

  return (
    <div className="card p-4 sm:p-5 flex flex-col justify-center h-full min-h-[200px] overflow-hidden">
      <p className="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2 sm:mb-3">Platform Statistics</p>

      {/* Main big numbers */}
      <div className="space-y-2 sm:space-y-3 mb-3 sm:mb-4">
        <div>
          <p className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-emerald-400 leading-none tracking-tight">
            +{fmtEur(totalEur)}
          </p>
          <p className="text-xs sm:text-sm text-gray-500 mt-1">Total profit earned</p>
        </div>

        <div>
          <p className="text-xl sm:text-2xl lg:text-3xl font-extrabold text-white leading-none tracking-tight">
            +{totalDeals.toLocaleString()} <span className="text-amber-400">clients</span>
          </p>
          <p className="text-xs sm:text-sm text-gray-500 mt-1">Successful trades</p>
        </div>
      </div>

      {/* Secondary row */}
      <div className="grid grid-cols-2 gap-2 sm:gap-3 pt-2 sm:pt-3 border-t border-white/[0.06]">
        <div>
          <p className="text-lg sm:text-xl font-extrabold text-amber-400">+{fmtEur(todayProfit)}</p>
          <p className="text-xs text-gray-500 mt-0.5">Today's profit</p>
        </div>
        <div>
          <p className="text-lg sm:text-xl font-extrabold text-white flex items-center gap-2">
            <span className="live-dot" />
            {activeUsers.toLocaleString()}
          </p>
          <p className="text-xs text-gray-500 mt-0.5">Online now</p>
        </div>
      </div>
    </div>
  )
}
